import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

import {
    clearCaptcha,
    clearCaptchaImageUrl,
    setCaptcha,
    setCaptchaImageUrl,
    userProfileLoading,
    userProfileLoadingFailed,
    userProfileLoadingSucceeded,
} from '../actions/partnersActionsCreators';

const loading = handleActions(
    {
        [userProfileLoading]: () => true,
        [userProfileLoadingFailed]: () => false,
        [userProfileLoadingSucceeded]: () => false,
    },
    false,
);

const loaded = handleActions(
    {
        [userProfileLoading]: () => false,
        [userProfileLoadingFailed]: () => false,
        [userProfileLoadingSucceeded]: () => true,
    },
    false,
);

const auth = handleActions(
    {
        [setCaptcha]: (state) => ({
            ...state,
            isNeedCaptcha: true,
        }),
        [setCaptchaImageUrl]: (state, action) => ({
            ...state,
            captchaImageUrl: action.payload,
        }),
        [clearCaptchaImageUrl]: (state) => ({
            ...state,
            captchaImageUrl: null,
        }),
        [clearCaptcha]: (state) => ({
            ...state,
            isNeedCaptcha: false,
        }),
    },
    {
        isNeedCaptcha: false,
        captchaImageUrl: null,
    },
);

const userProfile = combineReducers({
    loading,
    loaded,
    auth,
});
export default userProfile;

export const selectUserProfileState = (state) => state.userProfile;
